import Swal from 'sweetalert2';

const axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Initializes all modals
 */
 export default function InitModals() {
  
    const modalTriggers = document.querySelectorAll('[data-show-modal]');
    modalTriggers.forEach((element) => {
        element.addEventListener('click', function(event) {
            event.preventDefault();
            const modal = element.querySelector('[data-modal]');
            if(modal)
                showModal(parseModalConfig(modal));
        });
    });
}

function parseModalConfig(modalElement) {
    if(modalElement.innerHTML)
        modalElement.setAttribute('data-html', modalElement.innerHTML);
    modalElement.innerHTML = null;

    return {
        cancelButtonText: modalElement.getAttribute('data-cancel-text'),
        confirmButtonText: modalElement.getAttribute('data-confirm-text'),
        customContainerClass: modalElement.getAttribute('data-class'),
        icon: modalElement.getAttribute('data-icon'),
        html: modalElement.getAttribute('data-html'),
        showCancelButton: modalElement.getAttribute('data-show-cancel') === 'true',
        showCloseButton: modalElement.getAttribute('data-show-close') === 'true',
        text: modalElement.getAttribute('data-text'),
        title: modalElement.getAttribute('data-title'),
        url: modalElement.getAttribute('data-url'),
        useAjax: modalElement.getAttribute('data-ajax') === 'true',
        redirectOnConfirm: modalElement.getAttribute('data-redirect-on-confirm'),
    }
}

function showModal(config) {
    Swal.fire({
        title: config.title,
        text: config.text,
        icon: config.icon,
        html: config.html,
        showCancelButton: config.showCancelButton,
        showCloseButton: config.showCloseButton,
        confirmButtonText: config.confirmButtonText ? config.confirmButtonText : 'OK',
        cancelButtonText: config.cancelButtonText ? config.cancelButtonText : 'Cancel',
        customClass: {
            confirmButton: 'button-primary',
            container: config.customContainerClass
        },
        showClass: {
            popup: 'swal2-show',
            backdrop: 'swal2-backdrop-show',
            icon: 'swal2-icon-show'
        },
        didOpen: () => {
            if(config.showLoading)
                Swal.showLoading();
        },
        preConfirm: () => {
            if(!config.url)
                return;

            const form = document.querySelector('.swal2-html-container form');
            const formData = form ? new FormData(form) : new FormData();

            if(config.useAjax) {
                showModal({
                    showLoading: true
                });
                ajaxRequest('post', config.url, formData);
            }

           else window.location = config.url;  
        }
    }).then((result) => {
        if(result.isConfirmed && config.redirectOnConfirm) {
            if(config.redirectOnConfirm == 'reload')
                window.location.reload();
            else window.location = config.redirectOnConfirm;
        }
    });
}

function ajaxRequest(method, url, formData) {
    axios({
        method: method,
        url: url,
        data: formData,
    })
    .then((response) => {
        showModal(response.data);
    })
    .catch((error) => {
        if (error.response && isConfigSuitable(error.response.data))
            showModal(error.response.data);
        else {
            showModal({
                icon: 'error',
                text: 'Error while requesting data from server. Please reload the page and try again.'
            });
            console.error(error);
        }
    });
}

function isConfigSuitable(data) {
    if(!data)
        return false;

    return data.title != null |
        data.text != null |
        data.html != null;
}